export const typeFormations = [
    {
        label: "rh",
        value: "rh"
    },
    {
        label: "technique",
        value: "technique"
    }
]